export class ImageLazyLoader {
    private intersectionObserver: IntersectionObserver;

    public constructor(imageTags:HTMLImageElement[], onImageLoadingError=(img:HTMLImageElement)=>{}) {
        this.intersectionObserver =  new IntersectionObserver(function(entries, observer) {
            entries.forEach(entry=>{
                if(entry.isIntersecting) {
                    const target = entry.target as HTMLImageElement;
                    if(target.dataset.src === undefined) {
                        observer.unobserve(target);
                        return;
                    }
                    target.src= target.dataset.src
                    delete target.dataset.src;
                    target.classList.remove("lazyload");
                    if(target.dataset.alt !== undefined) {
                        target.alt = target.dataset.alt;
                        delete target.dataset.alt;
                    }
                    target.onerror=()=>onImageLoadingError(target);
                    observer.unobserve(target);
                }
            })
        })
        imageTags.forEach(img=>this.intersectionObserver.observe(img));
    }

    public unobserve(img:HTMLImageElement) {
        this.intersectionObserver.unobserve(img);
    }

    public observe(img:HTMLImageElement) {
        this.intersectionObserver.observe(img);
    }
}
